import React, { useState, useEffect, useContext } from "react";
import { Spin, Col, Row } from "antdv5";
import Container from "components/common/Container";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
//
import LocationMenu from "components/pages/MatchPage/LocationMenu";
import MatchLocation from "components/pages/MatchPage/MatchLocation";
import TabsBar from "components/pages/MatchPage/TabsBar";
import MatchPageTable from "components/pages/MatchPage/MatchPageTable";
import { MatchDetail } from "styles/MatchPage";
//
import useEffectOnce from "components/customHook/useEffectOnce";
import {
  GETJsonCity,
  GETJsonMatch,
  GETJsonMatchGame,
  GETJsonProvince,
  GETJsonTbgroup,
} from "../api";
import { context } from "components/context/Context";

interface IMatchGame {
  PlaceName: string;
  PlaceDistance: string;
  StringDate: string;
  Status: string;
  MatchGameName: string;
}
interface ISet<T> {
  data: T[];
  totalPage: number | null;
  loading: boolean;
}
type GameSet = ISet<IMatchGame>;

interface IProvince {
  ProvinceID: number;
  ProvinceName: string;
}
interface ICity {
  CityID: number;
  CityName: string;
  CountNumber: number;
}
interface IMatch {
  MatchID: number;
  MatchName: string;
}
interface IGameName {
  matchID: string;
  matchName: string;
}

const initialState: GameSet = {
  data: [],
  totalPage: null,
  loading: false,
};
const loadingState: GameSet = {
  data: [],
  totalPage: null,
  loading: true,
};

const MatchPage = () => {
  const { preventRefreshCount, loading: spinLoading } = useAPI();
  const { state, dispatch } = useContext(context);
  const [gameSet, setGameSet] = useState<GameSet>(initialState);
  const [trainSet, setTrainSet] = useState<GameSet>(initialState);
  const [location, setLocation] = useState<ICity[]>([]);
  const [matchID, setMatchID] = useState<string>("");
  const [type, setType] = useState<"match" | "train">("match");
  const [games, setGames] = useState<IMatch[]>([]);
  const [gameName, setGameName] = useState<IGameName>({
    matchID: "",
    matchName: "未选择鸽会",
  });
  const [province, setProvince] = useState<IProvince[]>([]);
  const [city, setCity] = useState<string>("");
  const [club, setClub] = useState([]);
  const [subMenu, setSubMenu] = useState<number | null>(null);
  const [active, setActive] = useState<number | null>(null);
  const handleList = (key: "match" | "train") => {
    setType(key);
    preventRefreshCount(
      () => fetchMatchGame(matchID, key === "match" ? 2 : 0),
      5
    );
  };
  const fetchMatchGame = async (matchID: string, type: number) => {
    const matchGames = await GETJsonMatchGame(matchID, type);
    const set =
      matchGames.length === 0
        ? {
            data: [],
            totalPage: null,
            loading: false,
          }
        : {
            data: matchGames,
            totalPage: matchGames[0].TotalCount,
            loading: false,
          };
    type === 2 ? setGameSet(set) : setTrainSet(set);
  };
  const fetchCounty = async (pid: number) => {
    setGames([]);
    setGameName({
      matchID: "",
      matchName: "未选择鸽会",
    });
    setClub([]);
    setMatchID("");
    setLocation([]);
    setLocation(await GETJsonCity(pid));
  };
  const fetchClub = async (cityID: number) => {
    setGameName({
      matchID: "",
      matchName: "未选择鸽会",
    });
    setMatchID("");
    setGames([]);

    const tbgroups = await GETJsonTbgroup(cityID);
    sessionStorage.setItem("gid", tbgroups[0].Gid);
    setClub(tbgroups);
  };
  const fetchGames = async (gid: number) => {
    const matches = await GETJsonMatch(gid);
    setGames(matches);
    if (matches.length !== 0) {
      setGameName({
        matchID: matches[0].MatchID,
        matchName: matches[0].MatchName,
      });
      setMatchID(matches[0].MatchID);
    } else {
      setGameName({
        matchID: "",
        matchName: "未选择鸽会",
      });
      setMatchID("");
    }
  };
  const onClickFetchList = async (gid: number) => {
    const selectedType = type === "match" ? 2 : 0;

    // get matches
    const matches = await GETJsonMatch(gid);
    if (matches.length === 0) {
      // no matches
      setGames([]);
      setGameName({
        matchID: "",
        matchName: "未选择鸽会",
      });
      setMatchID("");
      selectedType ? setGameSet(initialState) : setTrainSet(initialState);
      return;
    }

    // get games of first match
    const firstID = matches[0].MatchID;
    setMatchID(firstID);
    setGames(matches);
    setGameName({
      matchID: firstID,
      matchName: matches[0].MatchName,
    });
    const matchGames = await GETJsonMatchGame(firstID, selectedType);
    if (matchGames.length === 0) {
      selectedType ? setGameSet(initialState) : setTrainSet(initialState);
    } else {
      const set = {
        data: matchGames,
        totalPage: matchGames[0].TotalCount,
        loading: false,
      };
      selectedType ? setGameSet(set) : setTrainSet(set);
    }
  };
  const locationMenuOnClick = (provinceID: number, provinceName: string) => {
    setCity(provinceName);
    preventRefreshCount(() => fetchCounty(provinceID), 3);
    setSubMenu(null);
    setActive(null);
    setGameSet(initialState);
    setTrainSet(initialState);
  };
  const matchLocationCityOnClick = (cityID: number, i: number) => {
    i === subMenu ? setSubMenu(null) : setSubMenu(i);
    fetchClub(cityID);
    setActive(null);
    setType("match");
    setGameSet(initialState);
    setTrainSet(initialState);
  };
  const matchLocationSubmenuOnClick = (
    Gid: number,
    Name: string,
    Nickname: string,
    i: number
  ) => {
    dispatch({ clubID: Name, clubName: Nickname, gid: Gid });
    setActive(i);
    preventRefreshCount(() => onClickFetchList(Gid), 3);
    setGameSet(loadingState);
    setTrainSet(loadingState);
  };
  useEffectOnce(() => {
    GETJsonProvince().then((provinces) => {
      setProvince(provinces);
      dispatch({ pid: provinces[0].ProvinceID });
    });
  }, []);
  const tabsBarOnClick = (matchID: number, matchName: string) => {
    setMatchID(matchID.toString());
    setGameName({
      matchID: matchID.toString(),
      matchName,
    });
  };
  useEffect(() => {
    if (state?.pid) {
      preventRefreshCount(() => fetchCounty(state.pid), 5);
    }
    if (province[0]?.ProvinceName) {
      setCity(province[0].ProvinceName);
    }
  }, [province]);

  useEffect(() => {
    if (sessionStorage.getItem("gid") && club) {
      const gid = Number.parseInt(sessionStorage.getItem("gid") as string);
      preventRefreshCount(() => fetchGames(gid), 5);
    }
  }, [club]);

  return (
    <Spin spinning={spinLoading} tip={"请等候3秒"}>
      <DefaultLayout>
        <LocationMenu
          province={province}
          city={city}
          onClick={locationMenuOnClick}
        />
        <MatchDetail>
          <Container>
            <Row gutter={16}>
              <Col xs={24} md={6}>
                <MatchLocation
                  club={club}
                  active={active}
                  city={city}
                  location={location}
                  subMenu={subMenu}
                  cityOnClick={matchLocationCityOnClick}
                  submenuOnClick={matchLocationSubmenuOnClick}
                />
              </Col>
              <Col xs={24} md={18}>
                {active !== null && active !== undefined && active >= 0 ? (
                  <TabsBar
                    gameName={gameName}
                    games={games}
                    handleList={handleList}
                    listItemOnClick={tabsBarOnClick}
                  />
                ) : null}
                <MatchPageTable
                  type={type}
                  gameSet={gameSet}
                  trainSet={trainSet}
                />
              </Col>
            </Row>
          </Container>
        </MatchDetail>
      </DefaultLayout>
    </Spin>
  );
};

export default MatchPage;
